import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Gamepad icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Gamepad } from '@sravni/design-system-icons'
 *
 * <Gamepad />
 * ```
 */
var Gamepad = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Gamepad", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.564 8.592H8.52M7.042 7.114v2.957m4.9 2.958H8.058a.74.74 0 0 0-.484.18l-2.625 2.268c-1.051.908-2.66.001-2.425-1.367l1.294-7.5a2.956 2.956 0 0 1 2.914-2.454h6.538a2.957 2.957 0 0 1 2.914 2.454l1.294 7.501c.236 1.369-1.375 2.275-2.425 1.367l-2.625-2.269a.74.74 0 0 0-.484-.18Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("rect", { x: "12.819", y: "7.356", width: "1.998", height: "1.998", rx: ".999", transform: "rotate(45 12.819 7.356)", stroke: "currentColor", strokeWidth: "1.5", strokeLinejoin: "round" }))); });

export { Gamepad };
//# sourceMappingURL=Gamepad.js.map
